import type {SagaIterator} from 'redux-saga';
import Store from 'store/storages/cookieStorage';

import {LOCATION_CHANGED} from 'constants/actions';
import {BRONTO_ID, BRONTO_TID} from 'constants/bronto/bronto';

import {getUrlParameter} from 'libs/url';
import {call, takeEvery} from 'redux-saga/effects';

/**
 * Set id in the cookie bronto from query params.
 */
export function* setBrontoIdCookie(): SagaIterator {
    const brontoID = yield call(getUrlParameter, BRONTO_ID);
    if (brontoID) yield call([Store, 'write'], BRONTO_TID, brontoID);
}

/**
 * Begin of saga.
 */
export default function* bronto(): SagaIterator {
    yield takeEvery(LOCATION_CHANGED, setBrontoIdCookie);
}
